import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/search/portfolio-empty-state.webp")